import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../style/Nav.css";
import { useTranslation } from "react-i18next";

const NavBar = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav>
     <Link to="/">
      <img
        src="/images/ahmad hasoun 2 1.png"
        height={"128px"}
        width={"128px"}
        className="navb"
        alt="logo"
      />
      </Link>
      <ul>
        <li className={isActive("/") ? "active" : ""}>
          <Link to="/">
            <img
              src={isActive("/") ? "/images/home-2.svg" : "/images/home-1.svg"}
              alt="home"
            />
            <p className={isActive("/") ? "active-text" : ""}>
              {t("nav.home")}
            </p>
          </Link>
        </li>

        <li className={isActive("/categories") ? "active" : ""}>
          <Link to="/categories">
            <img
              src={
                isActive("/categories")
                  ? "/images/cat-2.svg"
                  : "/images/cat-1.svg"
              }
              alt="category"
            />
            <p className={isActive("/categories") ? "active-text" : ""}>
              {t("nav.categories")}
            </p>
          </Link>
        </li>
        <li className={isActive("/seller") ? "active" : ""}>
          <Link to="/seller">
            <img
              src={
                isActive("/seller")
                  ? "/images/Page-2.svg"
                  : "/images/Page-1.svg"
              }
              alt="seller"
            />
            <p className={isActive("/seller") ? "active-text" : ""}>
              {t("nav.seller")}
            </p>
          </Link>
        </li>
        <li className={isActive("/my-cart") ? "active" : ""}>
          <Link to="/my-cart">
            <img
              src={
                isActive("/my-cart")
                  ? "/images/cart-2.svg"
                  : "/images/cart-1.svg"
              }
              alt="cart"
            />
            <p className={isActive("/my-cart") ? "active-text" : ""}>
              {t("nav.cart")}
            </p>
          </Link>
        </li>

        <li className={isActive("/wishlist-page") ? "active" : ""}>
          <Link to="/wishlist-page">
            <img
              src={
                isActive("/wishlist-page")
                  ? "/images/heart1.svg"
                  : "/images/heart.png"
              }
              alt="wishlist"
            />
            <p className={isActive("/wishlist-page") ? "active-text" : ""}>
              {t("nav.wishlist")}
            </p>
          </Link>
        </li>

        <li className={isActive("/account") ? "active" : ""}>
          <Link to="/account">
            <img
              src={
                isActive("/account")
                  ? "/images/account-2.svg"
                  : "/images/account-1.svg"
              }
              alt="account"
            />
            <p className={isActive("/account") ? "active-text" : ""}>
              {t("nav.account")}
            </p>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
